module.exports = __webpack_public_path__ + "img/img_5.44241a96.png";